import { Navigate, createBrowserRouter } from 'react-router';

// project import
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import InitRoutes from './InitRoutes';
import ErrorPage from 'pages/error-page';
import MaintenancePage from 'pages/maintenance/maintenance';

// ==============================|| ROUTING RENDER ||============================== //

const BYPASS_STORAGE_KEY = 'maintenance_bypass';

function hasMaintenanceBypass(): boolean {
  const params = new URLSearchParams(globalThis.location.search);
  const bypassParam = params.get('bypass');

  if (bypassParam === import.meta.env.VITE_MAINTENANCE_BYPASS_KEY) {
    sessionStorage.setItem(BYPASS_STORAGE_KEY, 'true');
    return true;
  }

  return sessionStorage.getItem(BYPASS_STORAGE_KEY) === 'true';
}

export default function router() {
  const baseRoutes = [
    { ...LoginRoutes, errorElement: <ErrorPage /> },
    { ...InitRoutes, errorElement: <ErrorPage /> },
    { ...MainRoutes, errorElement: <ErrorPage /> },
    {
      path: '*',
      element: <Navigate to="/" replace />
    }
  ];

  const maintenanceRoutes = [
    {
      path: '/',
      element: <MaintenancePage />
    },
    {
      path: '*',
      element: <Navigate to="/" replace />
    }
  ];

  const isUnderMaintenance = import.meta.env.VITE_MAINTENANCE_MODE === 'True' && !hasMaintenanceBypass();

  if (isUnderMaintenance) {
    return createBrowserRouter(maintenanceRoutes, {
      basename: import.meta.env.VITE_APP_BASE_NAME
    });
  } else {
    return createBrowserRouter(baseRoutes, {
      basename: import.meta.env.VITE_APP_BASE_NAME
    });
  }
}
